import React from "react";
import { useTranslation } from "react-i18next";

export default function SkipToContent() {
  const { t } = useTranslation();
  return (
    <a
      href="#main"
      data-testid="skip-to-content"
      className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-[100] focus:px-3 focus:py-1.5 focus:rounded-md focus:bg-primary focus:text-primary-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400"
    >
      {t("a11y.skip_to_content", "Skip to content")}
    </a>
  );
}
